import * as React from 'react';
import { Map } from 'immutable';
import v4 from 'uuid/v4';

export type Boxe = React.ReactElement<any>;
export type Boxes = Map<string, Boxe>;
export type State = { boxes: Boxes };

export const initialState: State = {
  boxes: Map(),
};

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'floatingBoxes/ADD_BOX':
      return { boxes: state.boxes.set(action.uuid, action.box) };
    case 'floatingBoxes/REMOVE_BOX':
      return { boxes: state.boxes.delete(action.uuid) };
    default:
      return state;
  }
}

type AddBoxAction = {
  type: 'floatingBoxes/ADD_BOX';
  uuid: string;
  box: Boxe;
};

export function addBox(uuid: string = v4(), box: React.ReactElement<any>): AddBoxAction {
  return {
    type: 'floatingBoxes/ADD_BOX',
    uuid,
    box,
  };
}

type RemoveBoxAction = {
  type: 'floatingBoxes/REMOVE_BOX';
  uuid: string;
};

export function removeBox(uuid: string): RemoveBoxAction {
  return {
    type: 'floatingBoxes/REMOVE_BOX',
    uuid,
  };
}

export type FloatingBoxesAction = AddBoxAction | RemoveBoxAction;
